import { bubEvents } from 'shared/events/bub_events';
import { SiteConversionTrackingHelper, SiteImpressions } from 'shared/events/site_conversion_tracking_helper';

$(document).ready(() => {
  $('.sign-up-form .chirp-submit-button').click(() => {
    bubEvents.track('Signing nav', 'Clicked button', {
      label: 'User email address',
      value: $('.sign-up-form #user_email').val(),
    });
  });

  // NOTE: the signup form is used on multiple pages. On pages that only show a sign up
  // form (such as /users/sign_up), we want to track the conversion element that brought them to
  // the page, rather than treating the sign up form button click as the conversion.
  // So, here we're intentionally only tracking the sign up button click as a conversion on the checkout page.

  // On checkout/users/sign_up path.
  $('.checkout-registrations-new-content .sign-up-form .chirp-submit-button').click(event => {
    const signupTracker = new SiteConversionTrackingHelper('Inline full user signup form', event);
    signupTracker.trackConversion();
  });

  if ($('.auth-form.sign-up-form-wrapper:not(.hidden)').length) {
    if ($('#form-sign-up-btn-anon').length) {
      SiteImpressions.trackWhenInView({
        elementId: 'form-sign-up-btn-anon',
        category: 'Signing nav',
        action: 'Viewed signup button',
        eventLabel: 'Create Your Account and Continue',
        offset: 'bottom-in-view',
      });
    }
  }

  // On checkout/users/sign_in path. This acts as a "track immediately" event - we can see this
  // button after we click the Sign Up tab from the sign_in path.
  SiteImpressions.trackOnClick({
    elementIdOrClass: '#sign-up-header',
    category: 'Signing nav',
    action: 'Viewed signup button',
    eventLabel: 'Create Your Account and Continue',
  });

  // On shopping_cart/users/sign_up path.
  $('.shopping-cart-registrations-new-content .sign-up-form .chirp-submit-button').click(event => {
    const signupTracker = new SiteConversionTrackingHelper('Inline full user signup form', event);
    signupTracker.trackConversion();
  });

  $('.unbeatable-deals-content .email-sign-up-form .chirp-submit-button').click(event => {
    const signupTracker = new SiteConversionTrackingHelper('Inline user email signup form on unbeatable deals', event);
    signupTracker.trackConversion();
  });

  $('.unbeatable-deals-content .sticky-footer .cta').click(() => {
    bubEvents.track('Sticky footer CTA on unbeatable deals', 'Clicked button', {
      label: "See Today's Audiobook Deals",
    });
  });

  if ($('.shopping-cart-registrations-new-content .sign-up-form:not(.hidden)').length) {
    if ($('#form-sign-up-btn-anon').length) {
      SiteImpressions.trackWhenInView({
        elementId: 'form-sign-up-btn-anon',
        category: 'Signing nav',
        action: 'Viewed signup button',
        eventLabel: 'Create Your Account and Continue',
        offset: 'bottom-in-view',
      });
    }
  }

  // Slim header in logged-out collection pages & blog show pages
  $('.slim-header-form form').submit(event => {
    const emailAddress = document.getElementById('slim-header-sign-up-form-email-input').value;

    const signupTracker = new SiteConversionTrackingHelper('Slim header', event, {
      label: 'Sign Up for Free!',
      properties: {
        email: emailAddress,
      },
    });
    
    signupTracker.trackConversion();
  });
});
